import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "flex items-center text-black text-lg" };
var _hoisted_2 = { class: "form" };
var _hoisted_3 = { for: "uso" };
var _hoisted_4 = ["value"];
var _hoisted_5 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
var _hoisted_6 = {
    key: 0,
    class: "form"
};
var _hoisted_7 = { for: "motivo" };
var _hoisted_8 = ["placeholder"];
var _hoisted_9 = { class: "flex justify-between" };
import { onMounted, computed } from "vue";
import { ref } from "vue";
import { initFlowbite } from "flowbite";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { Modal } from "flowbite-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'farmaciModalSposta',
    emits: ["cancel"],
    setup: function (__props, _a) {
        var __expose = _a.expose, emit = _a.emit;
        var alertModal = ref(null);
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var terapienew = ref({});
        var alertConfirmMessage = ref(null);
        var showConfirm = ref(false);
        var farmacoSearch = ref("");
        var resolvePromise;
        var selectedTipoTerapia = ref(null);
        onMounted(function () {
            initFlowbite();
        });
        var stateList = ref([
            {
                value: 0,
                label: 'Farmaco Vietato'
            },
            {
                value: 2,
                label: 'Terapia Conclusa'
            },
            {
                value: 1,
                label: 'Terapia in Corso'
            }
        ]);
        // Evita di mostrare il proprio stato al modal
        var filteredStateList = computed(function () {
            return stateList.value.filter(function (item) { return String(item.value) !== String(terapienew.value.tipo_terapia); });
        });
        function openModal(message, rowData) {
            var _a;
            alertConfirmMessage.value = message;
            showConfirm.value = true;
            farmacoSearch.value = (_a = rowData.farmaco) === null || _a === void 0 ? void 0 : _a.descrizione_breve;
            terapienew.value = rowData;
            selectedTipoTerapia.value = rowData.tipo_terapia;
            return new Promise(function (resolve) {
                resolvePromise = resolve;
            });
        }
        function saveFarmaci() {
            alertModal.value.openModal("Sei sicuro di salvare i dati?", true).then(function (userInput) {
                if (userInput) {
                    terapienew.value.tipo_terapia = selectedTipoTerapia;
                    showConfirm.value = false;
                    if (!resolvePromise)
                        return;
                    resolvePromise(true);
                }
            });
        }
        function closeModal() {
            showConfirm.value = false;
            if (!resolvePromise)
                return;
            resolvePromise(false);
            emit("cancel");
        }
        __expose({ openModal: openModal });
        return function (_ctx, _cache) {
            return (showConfirm.value)
                ? (_openBlock(), _createBlock(_unref(Modal), {
                    key: 0,
                    size: "2xl",
                    onClose: _cache[4] || (_cache[4] = function ($event) { return (closeModal()); })
                }, {
                    header: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('Vuoi spostare il farmaco')) + "? ", 1)
                    ]; }),
                    body: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("Sposta il farmaco in")) + ": *", 1),
                            _withDirectives(_createElementVNode("select", {
                                id: "uso",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((selectedTipoTerapia).value = $event); }),
                                class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredStateList.value, function (item, key) {
                                    return (_openBlock(), _createElementBlock("option", {
                                        value: item.value,
                                        key: key
                                    }, _toDisplayString(item.label), 9, _hoisted_4));
                                }), 128))
                            ], 512), [
                                [_vModelSelect, selectedTipoTerapia.value]
                            ]),
                            _hoisted_5,
                            (_unref(terapienew).tipo_terapia == 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('Motivo')), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((_unref(terapienew).note) = $event); }),
                                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
                                        placeholder: _ctx.$t('Inserisci motivo')
                                    }, null, 8, _hoisted_8), [
                                        [_vModelText, _unref(terapienew).note]
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]; }),
                    footer: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("button", {
                                onClick: _cache[2] || (_cache[2] = function ($event) { return (closeModal()); }),
                                type: "button",
                                class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                            }, _toDisplayString(_ctx.$t('Annulla')), 1),
                            _createElementVNode("button", {
                                onClick: _cache[3] || (_cache[3] = function ($event) { return (saveFarmaci()); }),
                                type: "button",
                                class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            }, _toDisplayString(_ctx.$t('Sposta')), 1)
                        ]),
                        _createVNode(AlertModal, {
                            ref_key: "alertModal",
                            ref: alertModal
                        }, null, 512)
                    ]; }),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
